import React, { useEffect } from "react";
import { Button, Drawer, Space } from "antd";
import { Link } from "react-router-dom";
import { MenuOutlined } from "@ant-design/icons";
import styles from "./Drawer.module.scss";
import headerStyles from "./Header.module.scss";

export default function SideNav({ subdomains }) {
  const [open, setOpen] = React.useState(false);
  const [hideHamburger, setHideHamburger] = React.useState(false);

  const showDrawer = () => {
    setOpen(true);
    setHideHamburger(true);
  };

  const onClose = () => {
    setOpen(false);
    setHideHamburger(false);
  };

  let c_email = localStorage.getItem("email");

  return (
    localStorage.getItem("linkedInId") && (
      <>
        {hideHamburger || (
          <button className={styles.hamburger_button} onClick={showDrawer}>
            <MenuOutlined style={{ fontSize: "32px" }} />
          </button>
        )}

        <Drawer
          style={{ zIndex: 100000, backgroundColor: "#f5f5f5" }}
          className={styles.side_nav}
          title={
            <img
              src={require("assets/e3854688dbfbf6a330359a4774e76e55.png")}
              alt="alt text"
              onClick={() => window.open("/Home", "_self")}
              className={headerStyles.image}
            />
          }
          placement="left"
          closable={false}
          onClose={onClose}
          open={open}
          key="left"
        >
          <ul>
            <hr style={{ background: 'white' }}/>
            <div className={styles.side_nav__menu_item_account}>{ c_email }</div>
            <hr style={{ background: 'white' }}/>
            {subdomains.map((subdomain) => (
              <li key={subdomain.title}>
                <Link
                  className={styles.side_nav__menu_item}
                  to={subdomain.subdomain}
                >
                  {subdomain.title}
                </Link>
              </li>
            ))}
          </ul>
        </Drawer>
      </>
    )
  );
}
